<template>
  <!-- 안전 확인 -->
  <div class="widM pf23-inFo-safe-wrap pf23-lineBtm">
    <p class="fntP padTSM">{{ title }}<span class="ico-must-astar" v-if="isRequired"></span></p>
    <p class="fntP padTSM ">{{ description }}</p>

    <div class="clearfix marTSM">
      
      <template v-for="(participant, idx) in mainResponses" >
        <div :key="`participant-${sqCode}-${idx}`"
        :class="{'floL pcOnly': idx==0, 'floR': idx != 0}"
        >
          <template v-if="sqCode === 'Q119'">
            <!-- 안전확인 -->
            <div class="pf23-inFo-safe" :id="`Q119-${idx}`">
              <div class="amway-theme" style="width:55%;">
                <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
                  <label class="amw-radio-wrap radio-label focus">                  
                    <input
                      type="radio"
                      :name="`safety-radio-${idx}`"
                      class="amw-global-radio"
                      value="Y"
                      @change="inputRadioAnswer(`${idx}`, sqCode, 'Y')"
                      :checked="participant.questions[sqCode].raw_data === 'Y'"
                      :disabled="(!participant.attendance_yn || participant.attendance_yn === 'N') || !infoAvailable"
                    />
                    <span class="amw-radio-overlay"></span>
                    <span class="amw-label-radio-text">예</span>
                  </label>
                  <label class="amw-radio-wrap radio-label focus">
                    <input
                      type="radio"
                      :name="`safety-radio-${idx}`"
                      class="amw-global-radio"
                      value="N"
                      @change="inputRadioAnswer(`${idx}`, sqCode, 'N')"
                      :checked="participant.questions[sqCode].raw_data === 'N'"
                      :disabled="(!participant.attendance_yn || participant.attendance_yn === 'N') || !infoAvailable"
                    />
                    <span class="amw-radio-overlay"></span>
                    <span class="amw-label-radio-text">아니오</span>
                  </label>
                </div>
              </div>
            </div>
          </template>

          <template v-if="sqCode === 'Q120'">
            <!-- 알러지 -->
            <div class="pf23-ipE">
              <label :for="`NCAcmi_allergy01-${idx}`" class="fntP" style="display: none;">답변</label>
              <input type="text" 
                class="widM ip-Max" 
                maxlength='30'
                :id="`Q120-${idx}`"
                :name="`NCAcmi_allergy01-${idx}`" 
                :class="isRequired && participant.questions[sqCode].hasError ? 'check-red' : ''"
                :value="participant.questions[sqCode].raw_data"
                :disabled="(!participant.attendance_yn || participant.attendance_yn === 'N') || !infoAvailable"
                @input="inputAnyAnswer(idx, sqCode, $event.target)"
                >
            </div>            
          </template>

          <template v-if="sqCode === 'Q121'">
            <!-- 비자 -->
            <div class="">
              <div class="pf23-ipE">
                <label :for="`Q121-${idx}`"  class="fntP" style="display: none;">답변</label>
                <div class="pf23-inFo-safe">
                  <div class="amway-theme" style="width:55%;">
                    <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
                      <label class="amw-radio-wrap radio-label focus">
                        <input type="radio"
                          :id="`Q121-${idx}`"
                          :name="`visa-eta-radio-${idx}`"
                          class="amw-global-radio"
                          value="Y"
                          @change="inputVisaEtaAnswer(`${idx}`, sqCode, 'Y')"
                          :checked="participant.questions[sqCode].raw_data === 'Y'"
                          :disabled="(!participant.attendance_yn || participant.attendance_yn === 'N') || !infoAvailable"
                        >
                        <span class="amw-radio-overlay"></span>
                        <span class="amw-label-radio-text">예</span>
                      </label>
                      <label class="amw-radio-wrap radio-label focus">
                        <input type="radio" 
                          :name="`visa-eta-radio-${idx}`"
                          class="amw-global-radio"
                          value="Y"
                          @change="inputVisaEtaAnswer(`${idx}`, sqCode, 'N')"
                          :checked="participant.questions[sqCode].raw_data === 'N'"
                          :disabled="(!participant.attendance_yn || participant.attendance_yn === 'N') || !infoAvailable"
                        >
                        <span class="amw-radio-overlay"></span>
                        <span class="amw-label-radio-text">아니오</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <template v-if="participant.questions[sqCode].raw_data == 'Y'" >
              <div class="pf23-visa-wrap inFo-L" v-if="participant.questions[sqCode].raw_data == 'Y'">
                <div class="pf23-inFo-L padBSM padTSM pf23-inFo-common" >
                  <label :for="`Q122-${idx}`" class="fntP">비자 번호<span class="ico-must-astar"></span><br>(Visa Grant Number)
                  </label>
                  <input type="text"  maxlength='13'
                    :id="`Q122-${idx}`"
                    :name="`pf23visNum01-${idx}`" 
                    :class="isRequired && (participant.questions['Q122'].hasError && participant.questions['Q122'].raw_data) ? 'check-red' : ''"
                    :value="participant.questions['Q122'].raw_data"
                    :disabled="(!participant.attendance_yn || participant.attendance_yn === 'N') || !infoAvailable"
                    @input="inputVisaNumberAnswer(idx, 'Q122', $event.target)"
                    
                  >
                </div>
                <p v-if="isRequired && (participant.questions['Q122'].hasError && participant.questions['Q122'].raw_data)" class="marTS fntE padBSM" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">🚫  Visa 번호 13자리를 모두 입력해주세요.</p>

                <div class="pf23-inFo-L padBSM padTSM pf23-inFo-common" v-if="participant.questions[sqCode].raw_data == 'Y'">
                  <p class="fntP">비자 유효기간 <span class="ico-must-astar"></span><br>(Visa Expiry Date)</p>
                  <div class="pf23-inFo-select pf23-date">
                    <input
                      type="date"
                      :id="`Q123${idx}`"
                      :name="`NCAcmi_visa_expired_date${idx}`" 
                      style="width:100%"
                      class="NCAcmi_num"
                      :class="ishint && participant.questions['Q123'].hasError ? 'check-red' : ''"
                      :value="participant.questions['Q123'].raw_data"
                      @change="inputVisaEtaDateAnswer(idx, 'Q123', $event.target);"
                      size="50"
                      maxlength="50"
                      :disabled="(!participant.attendance_yn || participant.attendance_yn === 'N') || !infoAvailable"
                      :min="today"
                    />
                  </div>
                </div>
                <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"><template v-if="isRequired && ishint && participant.questions['Q123'].hasError">🚫 {{participant.questions['Q123'].remarks ? participant.questions['Q123'].remarks : '비자유효기간을 선택해 주세요.'}}</template></p>
                
              </div>
              <p class="marTS fntE padBSM" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">* AustrailanETA앱의 Visa Status &gt; Visa details에서 확인 가능합니다.</p>
              
            </template>
            <p class="marTS fntP padBSM"><a href="https://www.youtube.com/watch?v=wFp2yij2uUA&ab_channel=호뚜루뉴뚜루" style="color: #0075a4; font-weight: 500;" target="_blank">* <u>ETA 신청방법 확인하기 &gt;</u></a></p>        
            </div>    
          </template>
            
        </div>
      </template>
    </div>
    <p v-if="tooltip" class="marTS fntE padBSM" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">{{ tooltipMessage }}</p>
  </div>
  <!-- //안전 확인 -->
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { CommonMethodMixin } from '../mixins'
import {
  SURVEY_SYDNEY,
  SET_ATTENDANCE,
  CLEAR_RESPONSE_DATA,
  MAIN_RESPONSES,
  GET_CODE_PASSPORT_DATE,
  GET_CODE_TODAY,
} from '@/store/actions/survey'

export default {
  name: 'SurveyParticipantFloat',
  mixins: [CommonMethodMixin],
  props: {
    infoAvailable: {
      type: Boolean,
      required: false
    },
    title: { 
      type: String, 
      required: true
    },
    description : {
      type: String, 
      required: true
    },
    sqCode: { 
      type: String, 
      required: true
    },
    tooltip : {
      type: Boolean, 
      required: true
    },
    tooltipMessage : {
      type: String, 
      required: false
    },
    isRequired: {
      type: Boolean, 
      required: true
    },
  },
  computed: {
    ...mapState(SURVEY_SYDNEY, {
      hint: state => state.hint
    }),
    ...mapGetters(SURVEY_SYDNEY, {
      mainResponses: MAIN_RESPONSES,
      passportDate: GET_CODE_PASSPORT_DATE,
      today: GET_CODE_TODAY,
    }),
    ishint() {
      return this.infoAvailable && this.hint
    }
  },
  methods: {
    selectAttendance(e) {
      const attendance_yn = e.target.value;
      this.$store.commit(`${SURVEY_SYDNEY}/${SET_ATTENDANCE}`, { idx: this.idx, attendance_yn });
      if(attendance_yn === 'N') {
        this.$store.dispatch(`${SURVEY_SYDNEY}/${CLEAR_RESPONSE_DATA}`, this.idx);
      }
    },
  },
  data() {
    return {
      show: true
    }
  }
}
</script>

<style>
.hilight>label {
  color: red !important;
  font-weight: bold !important;
}

.heigthMore { 
  min-height: 75px;
}
</style>


// WEBPACK FOOTER //
// src/views/surveys/sydney/components/SurveyParticipantFloat.vue